import { useFrame, useThree } from "@react-three/fiber";
import { useRef, useState } from "react";
import * as THREE from "three";

export const useShowCorrectCoordinates = (
  showLabels,
  center,
  { coordinateData }
) => {
  const [positionAndLabelOutput, setPositionAndLabelOutput] = useState(null);

  const previousIsFrontRef = useRef(null);
  const previousIsRightRef = useRef(null);
  const previousDimensionsRef = useRef(null);
  const { camera } = useThree();

  console.log('show labels, center, coordinateData:', showLabels, center, coordinateData);

  const parseVector = (str) => {
    const [x, y, z] = str.split(",").map(Number);
    return new THREE.Vector3(x, y, z);
  };

  const updateValues = (isFront, isRight) => {
    if (!coordinateData || !coordinateData.positions) return;
    if (coordinateData.positions.fixed) return;

    previousIsFrontRef.current = isFront;
    previousIsRightRef.current = isRight;
    previousDimensionsRef.current = coordinateData.positions;

    console.log("isRight, isFront:", isRight, isFront);

    // Select correct positions & labels based on camera position
    const positions =
      !isRight && isFront
        ? coordinateData.positions
        : isRight && isFront
        ? coordinateData.positionsXInverted
        : !isRight && !isFront
        ? coordinateData.positionsZInverted
        : coordinateData.positionsXInvertedZInverted;

    const labels =
      !isRight && isFront
        ? coordinateData.positionLabels
        : isRight && isFront
        ? coordinateData.positionLabelsXInverted
        : !isRight && !isFront
        ? coordinateData.positionLabelsZInverted
        : coordinateData.positionLabelsXInvertedZInverted;

    console.log("COORDINATE DATA:", coordinateData);
    // console.log('POSITIONS:', positions);

    // Create output array with correct start, end, and labels
    const output = positions.map((arrow, index) => {
      const result = {
        start: arrow.start,
        end: arrow.end,
        label: labels[index]?.label,
        labelText: labels[index]?.labelText || "Missing Dimension Label",
        scaleFactor: coordinateData.scaleFactor,
        isRotational: arrow.isRotational,
      };
      if (arrow.offsetstart !== undefined && arrow.offsetend !== undefined) {
        result.offsetstart = arrow.offsetstart;
        result.offsetend = arrow.offsetend;
      }
      return result;
    });

    console.log("OUTPUT:", output);

    setPositionAndLabelOutput(output);
  };

  // Update camera direction in useFrame only
  useFrame(() => {
    //if (coordinateData) console.log('coordinateData:', coordinateData);
    if (!showLabels || !coordinateData) return;

    const { positions } = coordinateData;
    const isFront = camera.position.z > center.z;
    const isRight = camera.position.x > center.x;

    // Check if isFront or isRight has changed
    const hasIsFrontOrIsRightChanged =
      isFront !== previousIsFrontRef.current ||
      isRight !== previousIsRightRef.current;

    const hasDimensionsChanged = previousDimensionsRef.current !== positions;

    if (hasIsFrontOrIsRightChanged || hasDimensionsChanged) {
      updateValues(isFront, isRight);
    }
  });

  return { positionAndLabelOutput };
};
